import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

export const TIME_SLOTS = gql`
  query TimeSlots($projectId: ID!, $startAt: ISO8601DateTime!, $endAt: ISO8601DateTime!) {
    timeSlots(projectId: $projectId, startAt: $startAt, endAt: $endAt) {
      startAt
      endAt
    }
  }
`;

export const AUDIENCE_CAPACITY = gql`
  query AudienceCapacity($segmentId: ID!) {
    audienceCapacity(segmentId: $segmentId) {
      isCalendarFull
    }
  }
`;

export const SEGMENT = gql`
  query Segment($segmentId: ID!) {
    segment(id: $segmentId) {
      id
      device
      project {
        id
        name
        timeZone
      }
    }
  }
`;

export const getSegmentById = async (segmentId) => {
  const { data } = await client.getClient().query({
    query: SEGMENT,
    variables: { segmentId },
  });

  return data;
};

export const PROJECT = gql`
  query Project($projectId: ID!) {
    project(id: $projectId) {
      id
      name
      timeZone
      segments {
        id
        device
      }
    }
  }
`;

export const CREATE_SCHEDULED_TESTER = gql`
  mutation CreateScheduledTester(
    $projectId: ID!,
    $segmentId: ID!,
    $startAt: ISO8601DateTime!,
    $forceReschedule: Boolean!,
    $timeZone: String!
    $email: String,
    $firstName: String,
    $lastName: String,
  ) {
    createScheduledTester(
      projectId: $projectId,
      segmentId: $segmentId,
      startAt: $startAt,
      forceReschedule: $forceReschedule,
      timeZone: $timeZone
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
    ) {
      testSessionId
    }
  }
`;
